import { render, staticRenderFns } from "./gArrow.vue?vue&type=template&id=4b0bc1f8&scoped=true"
import script from "./gArrow.vue?vue&type=script&lang=js"
export * from "./gArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0bc1f8",
  null
  
)

export default component.exports